import { Download, FileText } from 'lucide-react';

interface Step2Props {
  documents: Record<string, { selectedFiles: any[] }>;
  onDownload: (name: string) => void;
}

export default function OrganizationDocs({ documents, onDownload }: Step2Props) {
  return (
    <section aria-labelledby='organization-documents-title'>
      <div className='bg-white sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-gray-900'>
            <div className='flex items-center'>
              <FileText className='w-6 h-6 text-gray-900 mr-2' />
              <h2 id='organization-documents-title' className='m-0 text-lg leading-6 font-medium text-gray-900'>
                Step 2: Organization Documents
              </h2>
            </div>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <div className='space-y-3'>
            {Object.entries(documents).map(([key, value]) => {
              console.log(value);
              const fileKey = value.selectedFiles?.[0]?.key;
              return (
                fileKey && (
                  <div key={key} className='flex items-center justify-between p-3 bg-gray-50 rounded-lg'>
                    <div className='flex items-center'>
                      <FileText className='w-5 h-5 text-gray-900 mr-2' />
                      <span className='text-sm text-gray-900'>Document {key.toUpperCase()}</span>
                    </div>
                    <button
                      onClick={() => onDownload(fileKey)}
                      className='flex items-center px-3 py-1 text-sm text-gray-700 hover:text-gray-900'
                    >
                      <Download className='w-4 h-4 mr-1' />
                      Download {key}
                    </button>
                  </div>
                )
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
